<aura-edit-wrapper
  title="Communes prioritaires pour les alertes"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-cities-form
      [preferredCities]="currentPreferredCities()"
      [selectedDepartments]="selectedDepartments()"
      [selectedDepartmentsSummary]="selectedDepartmentsSummary()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-cities-display [preferredCities]="currentPreferredCities()" />
  }
</aura-edit-wrapper>
